module.exports = __webpack_public_path__ + "img/subtract.4c5311f4.svg";